/**
 * ProfilePage — /profile route.
 * Mirrors Flutter WebProfile with profileTabIndex = 0: header + WebEditProfile.
 * (The Flutter left sidebar — avatar, tabs, delete account — is commented out on web;
 * View Jobs lives on its own /viewJobs route.)
 *
 * Flutter source:
 *   lib/presentation/web_profile/web_profile.dart
 */
import { PageLayout } from '@/components/layout/PageLayout';
import { EditProfileSection } from './components/EditProfileSection';

export function ProfilePage() {
  return (
    <PageLayout>
      <EditProfileSection />
    </PageLayout>
  );
}
